import React, { useMemo } from 'react';
import changelog from '../../generated/changelog.json';
import { useFeatures } from '../../hooks/useFeatures';
import { useIsAdmin, useIsSuperadmin } from '../../hooks/useIsAdmin';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { getAppVersion } from '../../utils/version';
import { CATEGORY_LABELS, ChangelogVersion, visibleVersions } from './changelogView';
import { BreadcrumbComponent } from '../../Components/BreadCrumb';
import './ChangelogPage.css';

/** Versionshistorik: the user-facing changes per released version, opened from the version label. */
const ChangelogPage: React.FC = () => {
    useDocumentTitle('Versionshistorik');
    const isAdmin = useIsAdmin();
    const isSuperadmin = useIsSuperadmin();
    const features = useFeatures();
    const currentVersion = getAppVersion().version;

    const versions = useMemo(
        () => visibleVersions(changelog as ChangelogVersion[], { isAdmin, isSuperadmin, features }),
        [isAdmin, isSuperadmin, features],
    );

    return (
        <>
        <BreadcrumbComponent items={[{ text: 'Versionshistorik' }]} />
        <div className="changelog-page">
            <header className="changelog-header">
                <h1 className="changelog-title page-title">Versionshistorik</h1>
                <p className="changelog-subtitle">Du använder version {currentVersion}.</p>
            </header>

            {versions.length === 0 && (
                <div className="std-box changelog-version">
                    <p className="changelog-empty">Det finns inga ändringar att visa ännu.</p>
                </div>
            )}

            {versions.map(version => (
                <section key={version.version ?? 'unreleased'} className="std-box changelog-version">
                    <h2 className="changelog-version-title">Version {version.version ?? currentVersion}</h2>
                    {version.groups.map(group => (
                        <div key={group.category} className="changelog-group">
                            <h3 className={`changelog-group-title changelog-group-title--${group.category}`}>
                                {CATEGORY_LABELS[group.category]}
                            </h3>
                            <ul className="changelog-list">
                                {group.entries.map(entry => (
                                    <li key={entry.slug}>
                                        {entry.area && <span className="changelog-area">{entry.area}: </span>}
                                        {entry.text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </section>
            ))}

        </div>
        </>
    );
};

export default ChangelogPage;
